import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Briefcase, 
  FolderKanban, 
  FileText, 
  Users, 
  Mail, 
  FileEdit, 
  Settings,
  Menu,
  X,
  LogOut
} from 'lucide-react';
import Logo from '@/components/Logo';
import { toast } from '@/App';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin/dashboard' },
    { icon: Briefcase, label: 'Hizmetler', path: '/admin/hizmetler' },
    { icon: FolderKanban, label: 'Projeler', path: '/admin/projeler' },
    { icon: FileText, label: 'Blog', path: '/admin/blog' },
    { icon: Users, label: 'Ekip', path: '/admin/ekip' },
    { icon: Mail, label: 'Mesajlar', path: '/admin/mesajlar' },
    { icon: FileEdit, label: 'Sayfalar', path: '/admin/sayfalar' },
    { icon: Settings, label: 'Ayarlar', path: '/admin/ayarlar' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    toast.success('Çıkış yapıldı');
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-50 w-64 glass border-r border-white/10 transition-transform duration-300 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="p-6 border-b border-white/10">
            <div className="flex items-center space-x-3">
              <Logo size="sm" />
              <span className="text-lg font-bold">Admin Panel</span>
            </div>
          </div>

          <nav className="flex-1 p-4 overflow-y-auto">
            <ul className="space-y-2">
              {menuItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    data-testid={`admin-nav-${item.path}`}
                    onClick={() => setSidebarOpen(false)}
                    className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                      location.pathname === item.path
                        ? 'bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white'
                        : 'text-white/70 hover:bg-white/5'
                    }`}
                  >
                    <item.icon className="w-5 h-5" />
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="p-4 border-t border-white/10">
            <button
              onClick={handleLogout}
              data-testid="admin-logout-button"
              className="flex items-center space-x-3 w-full px-4 py-3 rounded-lg text-white/70 hover:bg-white/5 transition-colors"
            >
              <LogOut className="w-5 h-5" />
              <span>Çıkış Yap</span>
            </button>
          </div>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Header */}
        <header className="glass border-b border-white/10 px-6 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="lg:hidden p-2 rounded-lg hover:bg-white/10 transition-colors"
              data-testid="mobile-sidebar-toggle"
            >
              {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            <div className="flex-1"></div>
            <div className="text-sm text-white/60">
              {JSON.parse(localStorage.getItem('user') || '{}').full_name || 'Admin'}
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;